var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState } from 'react';
import { Button, Loader, Menu, TableBodyCell, TableCellEmpty } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link } from 'react-router-dom';
import { ProjectDetailsPopover } from 'app/domains/projects';
import { useDocumentProjects } from './useDocumentProjects';
export function DocumentProjectsCell(props) {
    const { projectIds } = props, rest = __rest(props, ["projectIds"]);
    const hasProjects = Boolean(projectIds === null || projectIds === void 0 ? void 0 : projectIds.length);
    const [open, setOpen] = useState(false);
    const { projects, loading } = useDocumentProjects(projectIds !== null && projectIds !== void 0 ? projectIds : [], !open);
    const toggleMenu = () => setOpen(!open);
    const closeMenu = () => setOpen(false);
    if (!hasProjects) {
        return (<TableBodyCell {...rest}>
        <TableCellEmpty />
      </TableBodyCell>);
    }
    return (<TableBodyCell {...rest}>
      <Menu.Root open={open} onClose={closeMenu} align="end" target={<Button size="xs" appearance="secondary" disabled={loading} onClick={toggleMenu}>
            {loading ? <Loader /> : <Falcon icon="rectangle-history"/>}
            {projectIds === null || projectIds === void 0 ? void 0 : projectIds.length}
          </Button>}>
        {loading && (<Menu.Item disabled>
            <Loader size="xs"/>
          </Menu.Item>)}

        {projects.map((project) => (<ProjectDetailsPopover key={project.id} projectId={project.id}>
            <Menu.Item asChild>
              <Link to={`/projects/${project.id}`}>
                <Falcon icon="rectangle-history"/>
                {project.name}
              </Link>
            </Menu.Item>
          </ProjectDetailsPopover>))}
      </Menu.Root>
    </TableBodyCell>);
}
